"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const tracking_handler_1 = require("../../utils/browser/tracking-handler");
class PromptDialogComponent extends Marko.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            errorMessage: '',
            inputValue: '',
        };
    }
    onCreate(input) {
        const open = (0, get_1.default)(input, 'open', false);
        this.state = {
            open,
            errorMessage: '',
            inputValue: '',
        };
    }
    handleInputChange({ value }) {
        this.setState({ errorMessage: '' });
        const maxLength = (0, get_1.default)(this.input, 'inputField.maxLength', 0);
        const errorMessages = (0, get_1.default)(this.input, 'inputField.errorMessages', {
            maxLength: '',
            required: '',
        });
        if (maxLength > 0 && value.length > maxLength) {
            this.setState({ errorMessage: errorMessages.maxLength });
        }
        this.setState({ inputValue: value });
    }
    handleConfirm() {
        const maxLength = (0, get_1.default)(this.input, 'inputField.maxLength', 0);
        const errorMessages = (0, get_1.default)(this.input, 'inputField.errorMessages', {
            maxLength: '',
            required: '',
        });
        const confirmTrackingData = (0, get_1.default)(this.input, 'callToAction.confirm.trackingData', {});
        const { inputValue } = this.state;
        if (!inputValue) {
            this.setState({ errorMessage: errorMessages.required });
            return;
        }
        if (maxLength > 0 && inputValue.length > maxLength) {
            this.setState({ errorMessage: errorMessages.maxLength });
            return;
        }
        this.emit('confirm', { inputValue });
        (0, tracking_handler_1.handleTracking)(confirmTrackingData);
        this.setState({
            open: false,
            errorMessage: '',
            inputValue: '',
        });
    }
    handleCancel() {
        const confirmTrackingData = (0, get_1.default)(this.input, 'callToAction.cancel.trackingData', {});
        (0, tracking_handler_1.handleTracking)(confirmTrackingData);
        this.setState({
            open: false,
            errorMessage: '',
            inputValue: '',
        });
    }
}
exports.default = PromptDialogComponent;
